import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

const CAT_COLOR = {
  Technique: "#2563EB",
  Review: "#F59E0B",
  History: "#E63946",
  Guide: "#10B981",
  Curiosity: "#8B5CF6",
};

export const isNew = (a) => a?.created_at && Date.now() - new Date(a.created_at).getTime() < 7 * 864e5;

export const ArticleCard = ({ article, size = "md" }) => {
  const { t, lang } = useLang();
  const color = CAT_COLOR[article.category] || "#E63946";
  const large = size === "lg";

  return (
    <Link
      to={`/article/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block bg-[#14161b] border border-[#272b35] rounded-lg overflow-hidden hover:border-[#3a3f4b] transition-colors fade-up"
    >
      <div className={`relative overflow-hidden ${large ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
        <img
          src={article.cover_image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0c0d10] via-transparent to-transparent" />
        <span
          className="absolute top-3 left-3 px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest text-white rounded"
          style={{ backgroundColor: color }}
        >
          {article.category}
        </span>
        {isNew(article) && (
          <span data-testid={`new-badge-${article.slug}`} className="absolute top-3 right-3 px-2.5 py-1 text-[10px] font-mono font-bold uppercase tracking-widest bg-white text-black rounded animate-pulse">
            {lang === "it" ? "Nuovo" : "New"}
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className={`font-heading font-bold uppercase text-white leading-tight ${large ? "text-2xl sm:text-3xl" : "text-xl"}`}>
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-zinc-400 line-clamp-2">{article.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-zinc-500 font-mono">
          <span className="inline-flex items-center gap-1.5">
            <Clock size={13} /> {article.read_minutes} {t("min_read")}
          </span>
          <span className="inline-flex items-center gap-1 text-[#E63946] font-semibold group-hover:gap-2 transition-all">
            {t("read_more")} <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
};
